module.exports = {
  // EndPoint: "http://localhost:20001",
  // EndPoint: "https://backend.payfren.id/dev",
  // ApiSunrise: "https://mon-backend.payfren.id.id/dev",

  EndPoint: "https://rainbow.abbasyonline.com",
  ApiFren: "https://sunrise.abbasyonline.com",
  PayFren: "https://abbasyonline.com",
  Resource: "https://resource.abbasyonline.com/",

  // EndPoint: "https://backend.payfren.id",
  // ApiSunrise: "https://mon-backend.payfren.id",
  // Resource: "https://resource.abbasyonline.com/",
};
